import React from "react";
import { ScrollReveal } from "../components/ScrollReveal";
import { ProjectRow } from "../components/ProjectRow";

const projects = [
  {
    title: "TourVisto Dashboard",
    description:
      "Otomatisasi itinerary perjalanan berbasis AI melalui formulir dinamis. Sistem mengurai preferensi pengguna dan menyusun rencana perjalanan yang dipersonalisasi dalam hitungan detik.",
    tags: ["React.js", "Supabase", "React Router v7", "Shadcn UI", "Google OAuth"],
    demoUrl: "https://tourvisto-dashboard.vercel.app/",
  },
  {
    title: "Visual Thinkboard",
    description:
      "Papan manajemen tugas visual dengan tiga jalur progres: Belum Selesai, Sedang Berjalan, dan Selesai. Dirancang untuk kejelasan visual dan alur kerja yang intuitif.",
    tags: ["Vue.js", "Supabase", "Vue Router", "Tailwind CSS", "Clerk"],
    demoUrl: "https://visual-thinkboard.vercel.app/",
  },
  {
    title: "Info Film",
    description:
      "Platform eksplorasi dan rekomendasi film kaya infografis. Menghadirkan data sinematik dalam tata letak yang bersih dan mudah dinavigasi.",
    tags: ["React.js", "Tailwind CSS", "React Router", "IMDB API"],
    demoUrl: "https://movie-finder-akbarw.vercel.app/",
  },
];

export const CaseStudies: React.FC = () => {
  return (
    <section className="section-space" id="karya">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="flex items-baseline justify-between mb-4">
            <h2 className="text-sm uppercase tracking-widest text-muted-foreground font-medium">
              Karya
            </h2>
            <span className="text-sm text-muted-foreground">{String(projects.length).padStart(2, "0")} proyek</span>
          </div>
        </ScrollReveal>

        <div className="mt-8">
          {projects.map((project, i) => (
            <ScrollReveal key={project.title} delay={i * 0.1}>
              <ProjectRow {...project} index={i} />
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};
